import { querySelector, querySelectorAll } from '../functions/querySelectors';
import { TOTAL_PRICE_CLASS, TOTAL_PRICE_WITHOUT_VAT_ATTR, TOTAL_PRICE_DEFAULT_WITHOUT_VAT_ATTR } from '../functions/productChange';

const CLICK_ATTR = 'data-click-event';
const SUBMIT_ATTR = 'data-submit-event';
const BASKET_ATTR = 'data-add-to-cart-event';

const pushData = function(element, attribute) {
  let data = JSON.parse(element.getAttribute(attribute));

  if (window.dataLayer) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(data);
  }
};

const linkClick = function(event) {
  pushData(this, CLICK_ATTR);
};

const submitClick = function(event) {
  pushData(this, SUBMIT_ATTR);
};

const basketAddClick = function(event) {
  setTimeout(() => {
    let totalPriceElement = querySelector(`.${TOTAL_PRICE_CLASS}`);
    let data = JSON.parse(this.getAttribute(BASKET_ATTR));

    if (totalPriceElement) {
      let totalPrice = parseInt(totalPriceElement.getAttribute(TOTAL_PRICE_WITHOUT_VAT_ATTR), 10);

      if (!(totalPrice && !isNaN(totalPrice))) {
        totalPrice = parseInt(totalPriceElement.getAttribute(TOTAL_PRICE_DEFAULT_WITHOUT_VAT_ATTR), 10);
      }

      if (totalPrice && !isNaN(totalPrice)) {
        data.ecommerce.value = totalPrice;

        if (window.dataLayer) {
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push(data);
        }
      }
    }
  }, 0);
};

export function eventDataLayerActions() {
  let links = querySelectorAll(`[${CLICK_ATTR}]`);

  links.forEach((link) => {
    link.addEventListener('click', linkClick);
  });

  let submits = querySelectorAll(`[${SUBMIT_ATTR}]`);

  submits.forEach((submit) => {
    submit.addEventListener('submit', submitClick);
  });

  let basketAdds = querySelectorAll(`[${BASKET_ATTR}]`);

  basketAdds.forEach((basketAdd) => {
    basketAdd.addEventListener('click', basketAddClick);
  });
}
